import { downgradeComponent, downgradeInjectable } from "@angular/upgrade/static";
import { RouteConfigHelperProvider } from "@services/routeConfigHelper.provider";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { NPSDashboardComponent } from "./nps-dashboard/nps-dashboard.component";
import { NPSRaterComponent } from "./nps-rater.component";
import { NPSService } from "./nps.service";

export class Config {

    static $inject = ["$stateProvider", "routeConfigHelperProvider"];

    constructor(
        private $stateProvider: StateProvider,
        private routeConfigHelperProvider: RouteConfigHelperProvider) {
    }
}

angular
    .module("app.components.nps", ["app.directives"])
    .config(Config)

    .factory('npsService', downgradeInjectable(NPSService) as any)
    .directive("npsRater", downgradeComponent({ component: NPSRaterComponent }))
    .directive("npsDashboard", downgradeComponent({ component: NPSDashboardComponent }))
    ;
